import simple from '../SimpleLayout/SimpleLayoutConfig';

const LayoutsConfigs = {
  simple,
};

export default LayoutsConfigs;
